export default function modals() {
    const open_request_form = document.querySelectorAll('[data-target="open_request_form"]');
    const request_form = document.getElementById('request_form');
    const success_modal = document.getElementById('success_modal');
    const submit_button = document.getElementById('send-request');

    if (!open_request_form || !request_form) {
        return;
    }

    open_request_form.forEach(element => {
        element.addEventListener('click', () => {
            request_form.classList.add('open');
        })
    });

    Array.from(document.getElementsByClassName('close_modal')).forEach(element => {
        element.addEventListener('click', (e) => {
            request_form.classList.remove('open');
            success_modal.classList.remove('open');
        });
    });

    submit_button.addEventListener('click', (e) => {
        e.preventDefault();

        const form = e.target.closest('form');
        const name = form.querySelector('input[name="name"]').value;
        const phone = form.querySelector('input[name="phone"]').value;

        document.querySelector('input[name="name"]').parentElement.classList.remove('error');
        document.querySelector('input[name="phone"]').parentElement.classList.remove('error');

        if (!name || !phone) {
            if (!name) {
                document.querySelector('input[name="name"]').parentElement.classList.add('error');
            }
            if (!phone) {
                document.querySelector('input[name="phone"]').parentElement.classList.add('error');
            }

            return;
        }

        fetch('/post-feedback', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                name: name,
                phone: phone
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.result && response.result.length > 0) {
                    // Handle validation errors.
                    response.result.forEach(error => {
                        const input = document.querySelector(`input[name="${error.field}"]`);
                        if (input) {
                            input.parentElement.classList.add('error');
                        }
                    });
                } else {
                    form.querySelector('input[name="name"]').value = '';
                    form.querySelector('input[name="phone"]').value = '';

                    request_form.classList.remove('open');
                    success_modal.classList.add('open');
                    setTimeout(() => {
                        success_modal.classList.remove('open');
                    }, 3000);
                }
            });
    });

}
